<template>
  <div>
    <template v-if="renderContent">
      <div class="tab" :class="isActive ? 'tab__active' : 'tab__inactive'">
        <slot></slot>
      </div>
    </template>
    <template v-else>
      <div
        class="tab"
        v-if="isActive"
        :class="isActive ? 'tab__active' : 'tab__inactive'"
      >
        <slot></slot>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "tabs-content",
  props: {
    renderContent: Boolean,
    title: {
      type: String,
      default: "Tab"
    }
  },
  data: () => ({
    isActive: false,
    selectedIndex: 0
  })
}
</script>

<style lang="scss" scoped>
.tab {
  opacity: 1;
  overflow-wrap: break-word;
  transition: opacity ease 0.1s;

  &__inactive {
    height: 0;
    padding: 0 !important;
    opacity: 0;
    overflow: hidden;
    pointer-events: none;
  }
}
</style>
